import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.68 16.07l3.92-3.11V9.59c2.85-.93 5.94-.93 8.8 0v3.38l3.91 3.1L24 12.39c-6.41-7.19-17.59-7.19-24 0l3.68 3.68z"
}), 'CallEndSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallEndSharp.js
// module id = 2592
// module chunks = 2